import { render, staticRenderFns } from "./AllotOrderEdit.vue?vue&type=template&id=19fb889e&"
import script from "./AllotOrderEdit.vue?vue&type=script&lang=js&"
export * from "./AllotOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports